import { render, staticRenderFns } from "./FileCover.vue?vue&type=template&id=9efe8112&scoped=true&"
import script from "./FileCover.vue?vue&type=script&lang=js&"
export * from "./FileCover.vue?vue&type=script&lang=js&"
import style0 from "./FileCover.vue?vue&type=style&index=0&id=9efe8112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efe8112",
  null
  
)

export default component.exports